/**
 * Site configuration for public URLs
 * Uses environment variable or sensible defaults based on the current hostname
 */

/**
 * Get the public site URL for use in canonical tags, Open Graph, and other metadata
 * @returns The configured public site URL without trailing slash
 */
export const getPublicSiteUrl = (): string => {
  // First check if explicitly configured via environment variable
  if (import.meta.env.VITE_PUBLIC_SITE_URL) {
    return import.meta.env.VITE_PUBLIC_SITE_URL.replace(/\/$/, '');
  }

  // Fallback to current hostname in browser
  if (typeof window !== 'undefined') {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const port = window.location.port;
    
    // For localhost, include port
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return port ? `${protocol}//${hostname}:${port}` : `${protocol}//${hostname}`;
    }
    
    // For production domains
    return `${protocol}//${hostname}`;
  }

  // Default fallback for SSR or build time (use Vercel production URL)
  return 'https://excess-market.vercel.app';
};

/**
 * Check if we're running on the production domain
 */
export const isProduction = (): boolean => {
  if (typeof window === 'undefined') {
    return import.meta.env.PROD;
  }
  
  const hostname = window.location.hostname;
  // Consider both vercel.app and any future custom domains as production
  return hostname.includes('vercel.app') || 
         hostname.includes('excess-market.vercel.app') ||
         (!hostname.includes('localhost') && !hostname.includes('127.0.0.1'));
};
